import { External } from "components/icons/generated";
import TableCellLink from "ds/components/Table/Row/CellLink";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import { getCommitLabel } from "utils/commit";
import { providerHasVcsHost } from "utils/vcs";
import { StackContext } from "views/Stack/Context";
import { StackTaskRun } from "views/Stack/Tasks/gql";

const StackTasksTableCommitCell = ({
  item: task,
  ...cellProps
}: TableSimpleCellProps<StackTaskRun>) => {
  const { stack } = useTypedContext(StackContext);

  const hasVcsHost = providerHasVcsHost(stack.provider);
  const commitLabel = getCommitLabel(stack.provider, task.commit.hash);

  return (
    <TableSimpleCell {...cellProps}>
      {hasVcsHost && (
        <TableCellLink variant="primary" endIcon={External} target="_blank" href={task.commit.url}>
          {commitLabel}
        </TableCellLink>
      )}
      {!hasVcsHost && <TableCellText>{commitLabel}</TableCellText>}
    </TableSimpleCell>
  );
};

export default StackTasksTableCommitCell;
